import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { HelperService } from "../helperService";
@Injectable({
    providedIn: 'root'
})
export class APIBlockedReason {
    ApiURL: string = "";
    constructor(private http: HttpClient, private helperService: HelperService) {
        this.ApiURL = environment.BloquedReasonUrl + 'BlockedReason/';
    }
    public getByreasonAdvisor(): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        return this.http.get(this.ApiURL +'AdvisorReason',requestOptions);
    }

    public getByreasonworkshop(): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        return this.http.get(this.ApiURL +'WorkshopReason',requestOptions)
        // return this.http.get(this.ApiURL )
    }
    public get(reasonId: string): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
        };
        if (reasonId!== null && reasonId!== undefined) {
            return this.http.get(this.ApiURL + encodeURIComponent(reasonId),requestOptions);
       } else {
           return this.http.get(this.ApiURL,requestOptions );
        }
    }

  
}